import vAnimatedNumber from "./v-animated-number.vue";

export default Vue => {
  Vue.component("v-animated-number", vAnimatedNumber);
};
